// extracted by mini-css-extract-plugin
export default {"Container":"History_Container__R6lon","historyItem":"History_historyItem__UFNDm"};